import React, { useContext } from 'react';

import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';

import { useTooltip } from 'Wpds/components/tooltip/useTooltip';
import WpTooltipOverlay from 'Wpds/components/tooltip/WpTooltipOverlay';

import './ExpandButton.scss';

type Props = {
  onClick(): void;
};

function ExpandButton({ onClick }: Props) {
  const isExpanded = useContext(ExpandNavbarContext);

  const tooltip = useTooltip({ placement: 'right' });

  return (
    <>
      <WpButton size="sm" variant="tertiary" onClick={onClick} ref={tooltip.targetRef}>
        {isExpanded ? <WpIcon name="arrow-to-left" /> : <WpIcon name="arrow-to-right" />}
      </WpButton>
      <WpTooltipOverlay context={tooltip}>{isExpanded ? 'Collapse Menu' : 'Expand Menu'}</WpTooltipOverlay>
    </>
  );
}

export default ExpandButton;
